import { gql } from '@apollo/client'

export const UPDATE_STATE = gql`
  mutation updateState($input: UpdateStateInput!) {
    data: updateState(input: $input) {
      id
    }
  }
`
